var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModule7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5C5 3.3 6.3 2 8 2C9.7 2 11 3.3 11 5V7H13V5C13 2.2 10.8 0 8 0C5.2 0 3 2.2 3 5V7H5V5ZM9.5 12.5C9.5 11.7 8.8 11 8 11C7.2 11 6.5 11.7 6.5 12.5C6.5 12.9 6.7 13.3 7 13.6V15C7 15.6 7.4 16 8 16C8.6 16 9 15.6 9 15V13.6C9.3 13.3 9.5 12.9 9.5 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H3C1.3 7 0 8.3 0 10V17C0 18.7 1.3 20 3 20H13C14.7 20 16 18.7 16 17V10C16 8.3 14.7 7 13 7ZM9 13.6V15C9 15.6 8.6 16 8 16C7.4 16 7 15.6 7 15V13.6C6.7 13.3 6.5 12.9 6.5 12.5C6.5 11.7 7.2 11 8 11C8.8 11 9.5 11.7 9.5 12.5C9.5 12.9 9.3 13.3 9 13.6Z",
    fill: "#A2AACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule7);
export default __webpack_public_path__ + "static/media/module_7.14d711e85e3d6589c7ac1869a5a8f188.svg";
export { ForwardRef as ReactComponent };